<template>
    <div>
    
    <!--NAVBAR -->
    <nav class="navbar" role="navigation" aria-label="main navigation">
    
        <div class="navbar-brand">
            <a class="navbar-item" href="/">
                <img :src="staticUrl + 'basics/logo.png'">
            </a>
        </div>
  
        <div id="navbarBasicExample" class="navbar-menu">
            <div class="navbar-start">

            </div>
        
            <div class="navbar-end">
                <div class="navbar-item">
                    <div class="buttons">
                        <a 
                        class="button button is-primary" 
                        @click="requestDemo=true">
                            Solicitar demo
                        </a>
                    </div>
                </div>
            </div>
        </div>
  </nav>


    <div class="section background-main-section">
        <div class="columns is-mobile is-multiline">
            <div class="column is-half-tablet is-full-mobile">
                
                <h1 class="title is-size-1-desktop is-size-2-tablet is-size-3-mobile">Crea tu propio canal de ventas y contenido</h1>
                <p class="is-size-4-desktop">
                    Usando Traction, no tenes que pasar tiempo diseñando tu sitio web. 
                    Carga las imagenes, elige los colores, y estas listo para vender o publicar contenido.
                </p>
                
                <div class="buttons m-t-20">
                    <a class="button is-large is-primary" @click="requestDemo=true">
                        <strong>Solicitar demo</strong>
                    </a>
                </div>
            
            </div>

            <div class="column is-half-tablet is-full-mobile">
            <div class="container">
                <img class="landing_right_pic" :src="staticUrl + 'basics/landing_pc1.png'" alt="">
            </div>
            </div>
        </div>
    </div>

    <div class="section">
    <div class="columns is-centered is-multiline">

        <div class="column is-two-thirds feature-styles mb-5">
        <div class="level">
            <div class="level-item">
            <img :src="staticUrl + 'basics/illustrations/undraw_relaunch_day_902d.png'" width="200px">
            </div>
            
            <div class="is-block">
            <h1 class="title is-size-3">Rapida puesta en marcha.</h1>
            <p class="has-text-weight-semibold">
                No va a pasar mucho tiempo desde que decidas usar nuestra plataforma, hasta que inicies tus ventas. 
                Rellena las informacion basica de tu marca, usa los componentes pre-creados para cargar tu contenido al sitio, y ya estas listo para agregar tus productos. 
            </p>
            </div>
        
        </div>
        </div>

        <div class="column is-two-thirds feature-styles mb-5">
        <div class="level">

            <div class="level-item ">
            <img :src="staticUrl + 'basics/illustrations/undraw_payments.png'" width="200px">
            </div>

            <div class="is-block">
            <h1 class="title is-size-3">Medios de pago progresivos.</h1>
            <p class="has-text-weight-semibold">
                No tenes la presion de aceptar todos los medios de pago de entrada, es mas, si lo preferis, podes comenzar con una gestion de pagos manual.
                En todo momento, tenes control sobre los medios que queres usar para capturar pagos de tus clientes. 
                Nuestro proceso de compra se adapta a cualquier modalidad que decidas.
            </p>
            </div>
        
        </div>
        </div>


    </div>
    </div>

    <div class="section landing-features-section">
    <div class="has-text-centered no-skew has-text-white">
        <h1 class="title is-size-1 has-text-white">Sin inversion inicial, y tres meses gratis</h1>
        <p class="is-size-4 " >
        Nuestros planes, son todos en base a comisiones por venta.
        </p>
        <p class="is-size-4 ">
        Dependiendo los metodos de pago que utilices, tu volumen de ventas, y que monedas aceptes, 
        nuestras comisiones varian <strong class="has-text-white">desde el 1% hasta el 4% mas IVA. </strong>
        </p>

        <a 
        class="button is-large button is-primary is-inverted is-outlined m-t-20" 
        @click="requestDemo=true">
            Solicitar demo
        </a>

    </div>
    </div>


    <div class="section">
    
    <div class="columns is-centered is-multiline">
        <div class="column is-two-thirds feature-styles mb-5">
        <div class="level">

            <div class="level-item ">
            <img :src="staticUrl + 'basics/illustrations/undraw_accept.png'" width="200px">
            </div>

            <div class="is-block">
            <h1 class="title is-size-3">Catalogo robusto.</h1>
            <p class="has-text-weight-semibold">
                Gestiona todos tus productos desde el mismo lugar. 
                No importa si se trata de un producto simple, uno complejo con mas de una variante, o un clasificado como un auto o un inmueble.
            </p>
            </div>
        
        </div>
        </div>

        <div class="column is-two-thirds feature-styles mb-5">
        <div class="level">
    
            <div class="level-item ">
            <img :src="staticUrl + 'basics/illustrations/undraw_advanced.png'" width="200px">
            </div>
    
            <div class="is-block">
            <h1 class="title is-size-3">Facil manejo de ventas.</h1>
            <p class="has-text-weight-semibold">
                Facil manejo del estado de ordenes, que facilitan tu trabajo y deja a tu cliente tranquilo. 
                Comunicamos automaticamente a tu comprador cada cambio de estado en su orden, y tambien podes tener una comunicacion directa con el desde el mismo panel.
            </p>
            </div>
        
        </div>
        </div>

    </div>
    </div>

    <b-modal :active.sync="requestDemo" scroll="keep">
        <div class="modal-card" style="width: auto">
         
            
            <div class="modal-card-body">
                <b-field label="Email">
                    <b-input
                    v-model="demo.email"
                    type="email">

                    </b-input>
                </b-field>
                <b-field label="Numero de telefono">
                    <b-input
                    v-model="demo.phoneNumber"
                    >
                    </b-input>
                </b-field>
                <b-field>
                    <b-checkbox v-model="demo.acceptTerms">
                        Confirma que estas de acuerdo con nuestra politica de privacidad.
                    </b-checkbox>
                </b-field>
                <b-field>
                    <VueRecaptcha @verify="verifyCaptcha" sitekey="6LcHavwUAAAAAGnN37OSgSLR7e9XfivBHo7xGRwd"/>
                </b-field>
                <b-field>
                    <b-button
                    type="is-primary"
                    @click="createDemoRequest"
                    :disabled="disabledBtn"
                    :loading="loading">
                    Enviar solicitud
                    <b-icon class="m-l-5" icon="paper-plane" size=is-small></b-icon>
                    </b-button>
                </b-field>
            </div>

        </div>
    </b-modal>


    </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { postHandler } from '../../../services/http';

export default {
    components:{
        VueRecaptcha
    },
    props:{
        staticUrl:{
            type: String,
            default: ""
        },
        postUrl:{
            type: String,
            default:""
        }
    },
    data(){
        return{
            requestDemo:false,
            loading:false,
            captchaToken:"",
            demo:{}
        }
    },
    methods:{
        verifyCaptcha(token){
            this.captchaToken=token
            this.disabledBtn
        },
        async createDemoRequest(){
            var error = {
                resource:"toast",
                text:"Verifica que estan los datos requeridos ingresados y que validaste el captcha"
            }
            var success = {
                resource:"toast",
                text:"Solicitud creada con exito!!"
            }
            this.loading = true
            let resp = await postHandler(this.postUrl, this.demo, {error, success})
            this.loading = false
            this.requestDemo=false
            this.demo = {}
        }
    },
    computed:{
        disabledBtn(){
            var value = !this.demo.email || !this.demo.phoneNumber || !this.demo.acceptTerms || !this.captchaToken
            return value
        }
    }
}

</script>




<style lang="scss" scoped>
.landing_right_pic{
    border-radius: 10px;
    box-shadow: 2px 4px 9px 1px rgba(51, 51, 51, 0.465);
    transform: rotate(-10deg) scaleX(0.95);
  }
  .background-main-section{
/*    background-image: linear-gradient(513deg, rgba(248, 248, 248, 0.04) 0%, rgba(248, 248, 248, 0.04) 54%,rgba(112, 112, 112, 0.04) 54%, rgba(112, 112, 112, 0.04) 100%),linear-gradient(523deg, rgba(252, 252, 252, 0.04) 0%, rgba(252, 252, 252, 0.04) 66%,rgba(111, 111, 111, 0.04) 66%, rgba(111, 111, 111, 0.04) 100%),linear-gradient(425deg, rgba(40, 40, 40, 0.04) 0%, rgba(40, 40, 40, 0.04) 44%,rgba(168, 168, 168, 0.04) 44%, rgba(168, 168, 168, 0.04) 100%),linear-gradient(571deg, rgba(40, 40, 40, 0.04) 0%, rgba(40, 40, 40, 0.04) 78%,rgba(141, 141, 141, 0.04) 78%, rgba(141, 141, 141, 0.04) 100%),linear-gradient(374deg, #e9db85,#f32744); */
    background-image: 
      linear-gradient(236deg, rgba(247,145,15, 0.42) 0%, rgba(247,145,15, 0.42) 27%,rgba(249,242,242, 0.02) 27%, rgba(249,242,242, 0.02) 100%),
      linear-gradient(294deg, rgba(247,145,15, 0.43) 0%, rgba(247,145,15, 0.43) 43%,rgba(99,37,37, 0) 43%, rgba(99,37,37, 0) 100%),
      linear-gradient(323deg, rgba(247,145,15, 0.43) 0%, rgba(247,145,15, 0.43) 24%,rgba(255,255,255, 0.5) 24%, rgba(255,255,255, 0.5) 100%),
      linear-gradient(239deg, rgba(247,145,15, 0.43) 0%, rgba(247,145,15, 0.43) 45%,rgba(255,255,255, 0.5) 45%, rgba(255,255,255, 0.5) 100%),
      linear-gradient(90deg, rgba(212,197,103, 0.03),rgba(241,16,48, 0.03));
  }
  .landing-features-section{
    margin-top: 50px;
    margin-bottom:50px;
    background-color:rgb(224, 134, 16);
    transform: skewY(-4deg); 
  }
  .no-skew{
    transform: skewY(4deg);
  }

  .feature-styles{
    border-radius: 10px;
    box-shadow: 2px 5px 10px 1px rgba(51, 51, 51, 0.35);
    margin-bottom:35px;
  }

@media (max-width: 767px){
  .background-main-section{
    background-image: 
      linear-gradient(294deg, rgba(247,145,15, 0.43) 0%, rgba(247,145,15, 0.43) 43%,rgba(99,37,37, 0) 43%, rgba(99,37,37, 0) 100%),
      linear-gradient(323deg, rgba(247,145,15, 0.43) 0%, rgba(247,145,15, 0.43) 24%,rgba(255,255,255, 0.5) 24%, rgba(255,255,255, 0.5) 100%),
      linear-gradient(90deg, rgba(212,197,103, 0.03),rgba(241,16,48, 0.03));
  }
  .column{
    padding: 25px;
  }
}
</style>